module.exports = __webpack_public_path__ + "static/media/img6.84e7deb2.jpeg";